import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';

import { AccessorialInventoryService } from '@ruby/core/http/accessorial-inventory/accessorial-inventory.service';
import { IAccessorial, ILeaseTrackResponse } from '@ruby/modules/accessorial-inventory/models/accessorial-inventory.interface';
import * as AccessorialInventoryActions from '@ruby/modules/accessorial-inventory/store/actions/accessorial-inventory.actions';
import { IError } from '@ruby/shared/models/request/error.interface';
import { UtilsService } from '@ruby/shared/services/utils/utils.service';

@Injectable()
export class AccessorialInventoryEffects {
  fetchAccessorialDetails$ = createEffect(() => this.actions$.pipe(
    ofType(AccessorialInventoryActions.loadAccessorial),
    exhaustMap(action => this.accessorialService.fetchAccessorialDetails(action.data).pipe(
      map((accessorial: IAccessorial) => AccessorialInventoryActions.loadAccessorialSuccess({ data: accessorial })),
      catchError((error: IError) => {
        this.utilsSvc.showErrorToastr(error.title, error.message);
        this.router.navigate(['./home/dashboard']);

        return of(AccessorialInventoryActions.loadAccessorialFailure({ error }));
      })
    ))
  ));

  fetchLeaseTrackDetails$ = createEffect(() => this.actions$.pipe(
    ofType(AccessorialInventoryActions.loadLeaseTrack),
    exhaustMap(action => this.accessorialService.fetchLeaseTrackDetails(action.data).pipe(
      map((leaseTrack: ILeaseTrackResponse) => AccessorialInventoryActions.loadLeaseTrackSuccess({ data: leaseTrack })),
      catchError((error: IError) => {
        this.utilsSvc.showErrorToastr(error.title, error.message);
        return of(AccessorialInventoryActions.loadLeaseTrackFailure({ error }));
      })
    ))
  ));

  constructor(
    private actions$: Actions,
    private accessorialService: AccessorialInventoryService,
    private utilsSvc: UtilsService,
    private router: Router
  ) { }
}
